import { useEffect } from "react";
import { Link } from "react-router-dom";
import useMode from "../../Hooks/useMode";
//import logo from "../../images/logo.svg";
import { Moon, Sun } from "../../svg/svg";
import "./Navigation.css";

const Navigation = () => {
  const { theme, handleDark, handleLight } = useMode();

  useEffect(() => {
    const scrollProgress = document.querySelector(".scroll-progress");
    let navbar = document.querySelector(".navbar-container");
    const navbar_btn = document.querySelector(".mobile-navbar-btn");
    let lastScrollTop = 0;

    navbar_btn.addEventListener("click", () => {
      navbar.classList.toggle("actived");
    });

    //scroll
    document.addEventListener("scroll", () => {
      const totalWebpageHeight = document.body.scrollHeight;
      const currentDistanceHeight = document.documentElement.scrollTop;
      const webpageHeight = document.documentElement.clientHeight;

      const parcentageScroll =
        (currentDistanceHeight / (totalWebpageHeight - webpageHeight)) * 100;

      scrollProgress.style.width = Math.round(parcentageScroll) + "%";

      //navbar
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        navbar.style.top = "-65px";
      } else {
        navbar.style.top = "0px";
      }
      lastScrollTop = scrollTop;
    });
  }, []);

  return (
    <>
      <div
        className={`${
          theme === "light" ? "navbar-container-light" : "navbar-container-dark"
        } navbar-container`}
      >
        <Link className="logo" to="/">
          <p style={{ fontSize: "20px" }}>
            Fahim
            <span style={{ color: "#f9004d", fontSize: "12px" }}>.dev</span>
          </p>
        </Link>

        <nav
          className={`${
            theme === "light" ? "navbar-menu-light" : "navbar-menu-dark"
          } navbar-menu`}
        >
          <ul className="navbar-menu-list">
            <Link
              to="/blog"
              className={`${
                theme === "light" ? "text-dark" : "text-light"
              } navbar-link px-4`}
            >
              Blogs
            </Link>

            {theme === "light" ? (
              <button
                onClick={handleDark}
                className="border border-0 bg-transparent"
              >
                <Moon />
              </button>
            ) : (
              <button
                onClick={handleLight}
                className="border border-0 bg-transparent"
              >
                <Sun />
              </button>
            )}
          </ul>
        </nav>
        <div className="mobile-navbar-btn">
          <ion-icon
            name="menu-outline"
            class={`${
              theme === "light"
                ? "mobile-nav-icon-dark"
                : "mobile-nav-icon-light"
            } mobile-nav-icon`}
          ></ion-icon>
          <ion-icon
            name="close-outline"
            class={`${
              theme === "light"
                ? "mobile-nav-icon-dark"
                : "mobile-nav-icon-light"
            } mobile-nav-icon`}
          ></ion-icon>
        </div>
      </div>
      <div className="scroll-progress"></div>
    </>
  );
};

export default Navigation;
